module.exports = __webpack_public_path__ + "img/logotipo.6800eb94.png";